import { useState } from "react";
import {
  EditIncomeModalData,
  EditTransactionsModalData,
  OverrideIncomeModalData
} from "../../../types";

export const useModalsController = () => {
  const [showRerunModal, setShowRerunModal] = useState(false);
  const [showCancelRerunModal, setShowCancelRerunModal] = useState(false);
  const [showReverifyIncomeModal, setShowReverifyIncomeModal] = useState<
    number | false
  >(false);
  const [showEditIncomeModal, setShowEditIncomeModal] = useState<
    false | EditIncomeModalData
  >(false);
  const [showOverrideVerificationModal, setShowOverrideVerificationModal] =
    useState<false | OverrideIncomeModalData>(false);
  const [showEditTransactionsModal, setShowEditTransactionsModal] = useState<
    false | EditTransactionsModalData
  >(false);

  return {
    showRerunModal,
    setShowRerunModal,
    showCancelRerunModal,
    setShowCancelRerunModal,
    showReverifyIncomeModal,
    setShowReverifyIncomeModal,
    showEditIncomeModal,
    setShowEditIncomeModal,
    showOverrideVerificationModal,
    setShowOverrideVerificationModal,
    showEditTransactionsModal,
    setShowEditTransactionsModal
  };
};
